
import {
  ECommonContentLayout,
  EEvolveLandingPageTabs,
  thunkActionLoading,
} from '@configs'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  createEvolveBannerTopAction,
  getEvolveBannerTopAction,
  useAppDispatch,
  useAppSelector,
} from '@redux'
import { message } from 'antd'
import { t } from 'i18next'
import queryString from 'query-string'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { IMediaItem } from 'src/interfaces/gallery'
import { bannerTopSchema, IBannerTop } from './bannerSchema'

interface IAboutUsPageTabItemProps {
  activeTab?: string
}

export const useBannerTop = ({ activeTab }: IAboutUsPageTabItemProps) => {
  const [isModalLoading, setIsModalLoading] = useState(false)
  const dispatch = useAppDispatch()

  const [isChange, setIsChange] = useState(false)

  const [showModalSelectMedia, setShowModalSelectMedia] = useState(false)
  const [selectedField, setSelectedField] = useState<
    'desktop' | 'mobile' | null
  >(null)
  const onChangeDesktopRef = useRef<any>(null)
  const onChangeMobileRef = useRef<any>(null)

  const createBannerTopActionLoading = useAppSelector(
    (state) =>
      state.evolveLanding.loadings[thunkActionLoading.CREATE_BANNER_TOP_LOADING]
  )

  const getBannerTopActionLoading = useAppSelector(
    (state) =>
      state.evolveLanding.loadings[thunkActionLoading.GET_BANNER_TOP_LOADING]
  )

  const bannerTop = useAppSelector((state) => state.evolveLanding.bannerTop)

  const [imageSrc, setImageSrc] = useState(bannerTop?.media?.url ?? '')
  const [imageMobileSrc, setImageMobileSrc] = useState(
    bannerTop?.mediaMobile?.url ?? ''
  )

  const isDisabledSaveButton = useMemo(() => {
    return createBannerTopActionLoading || false
  }, [createBannerTopActionLoading])

  const { handleSubmit, control, setValue, getValues } = useForm<IBannerTop>({
    defaultValues: {
      title: bannerTop?.title ?? '',
      titleInDutch: bannerTop?.titleInDutch ?? '',
      subTitle: bannerTop?.subTitle ?? '',
      subTitleInDutch: bannerTop?.subContentInDutch ?? '',
      mediaId: bannerTop?.media?.id,
      mediaMobileId: bannerTop?.mediaMobile?.id,
      textColor: '',
      layout: ECommonContentLayout.LAYOUT_ONE,
      type: 'EVOLVE_TOP_BANNER',
    },
    resolver: zodResolver(bannerTopSchema),
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  })
  const onSubmit = async (data: IBannerTop) => {
    try {
      const responseCreateLanding = await dispatch(
        createEvolveBannerTopAction(data as any)
      ).unwrap()

      if (responseCreateLanding.success) {
        message.success({
          content: responseCreateLanding?.message ?? t('common:save_success'),
        })
      }
    } catch (error: any) {
      message.error({
        content:
          error?.message ?? t('error:some_thing_went_wrong_please_try_again'),
      })
    }
  }

  const onSave = () => {
    handleSubmit(onSubmit)()
    setIsChange(false)
  }

  const onPreview = (data: IBannerTop) => {
    const payload = {
      title: data.title,
      url: imageSrc,
      urlMobile: imageMobileSrc,
      type: 'evolve',
      textColor: data.textColor,
      layout: data.layout,
      // page: 'Evolve landing',
      mediaDescription: data.subTitle,
    }
    const stringified = queryString.stringify(payload)

    const URL = `${process.env.REACT_APP_PUBLIC_WEB_DOMAIN}/preview-content?${stringified}`
    window.open(URL, '_blank')
  }

  const onCloseModalSelectMedia = () => {
    setShowModalSelectMedia(false)
  }

  const onSelectMedia = (data: IMediaItem) => {
    if (selectedField === 'desktop') {
      setImageSrc(data?.baseUrl ?? '')
      setValue('mediaId', data?.id ?? 0)
      onChangeDesktopRef.current(data?.id ?? 0)
    } else if (selectedField === 'mobile') {
      setImageMobileSrc(data?.baseUrl ?? '')
      setValue('mediaMobileId', data?.id ?? 0)
      onChangeMobileRef.current(data?.id ?? 0)
    }

    setShowModalSelectMedia(false)
    setIsChange(true)
  }
  useEffect(() => {
    if (activeTab === EEvolveLandingPageTabs.BANNER) {
      const getBannerTop = async () => {
        try {
          const responseGetLanding = await dispatch(
            getEvolveBannerTopAction()
          ).unwrap()

          if (responseGetLanding.success) {
            setIsChange(false)
          }
        } catch (error: any) {
          // message.error({
          //   content:
          //     error.message ??
          //     t('error:some_thing_went_wrong_please_try_again'),
          // })
        }
      }
      getBannerTop()
    }
  }, [activeTab, dispatch, setValue])

  useEffect(() => {
    if (bannerTop) {
      if (Object.keys(bannerTop).length) {
        setValue('title', bannerTop?.title)
        setValue('titleInDutch', bannerTop?.titleInDutch)
        setValue('subTitle', bannerTop?.subTitle ?? '')
        setValue('subTitleInDutch', bannerTop?.subTitleInDutch ?? '')
        setValue('mediaId', bannerTop?.media?.id)
        setValue('mediaMobileId', bannerTop?.mediaMobile?.id)
        setValue('textColor', bannerTop?.metaData?.textColor)
        setValue('layout', bannerTop?.metaData?.layout)
        setImageSrc(bannerTop?.media?.url ?? '')
        setImageMobileSrc(bannerTop?.mediaMobile?.url ?? '')
      }
    }
  }, [bannerTop])
  return {
    getBannerTopActionLoading,
    control,
    setIsChange,
    onChangeDesktopRef,
    setValue,
    setImageSrc,
    setSelectedField,
    setShowModalSelectMedia,
    imageSrc,
    getValues,
    isModalLoading,
    setIsModalLoading,
    onChangeMobileRef,
    isDisabledSaveButton,
    imageMobileSrc,
    onSubmit: handleSubmit(onPreview),
    onSave,
    isChange,
    showModalSelectMedia,
    onCloseModalSelectMedia,
    onSelectMedia,
  }
}
